import { render, staticRenderFns } from "./afterRentStatistics.vue?vue&type=template&id=1872f21e&scoped=true&"
import script from "./afterRentStatistics.vue?vue&type=script&lang=js&"
export * from "./afterRentStatistics.vue?vue&type=script&lang=js&"
import style0 from "./afterRentStatistics.vue?vue&type=style&index=0&id=1872f21e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1872f21e",
  null
  
)

export default component.exports